import { channelsApi } from "./controller"

export const selectApiDeclarations = channelsApi.endpoints.getDeclarations.select
export const selectApiChannels = (projectId: string) =>
    channelsApi.endpoints.getChannels.select({ projectId, declarations: {} })
export const selectApiWebChatAdditionalData = (projectId: string, channelId: string) =>
    channelsApi.endpoints.getWebChatAdditionalData.select({ projectId, channelId })
